(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalFirmInsuranceController', AppraisalFirmInsuranceController);

    AppraisalFirmInsuranceController.$inject = ['AppraisalFirm', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function AppraisalFirmInsuranceController(AppraisalFirm, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;
        vm.firms = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchQuery = pagingParams.search;
        vm.missingOnly = pagingParams.missingOnly;
        vm.transition = transition;
        vm.openFirm = openFirm;

        loadAll();

        function loadAll() {
            AppraisalFirm.getProofOfInsuranceSummary({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                query: vm.searchQuery,
                missingOnly: vm.missingOnly ? true : undefined
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.firms = data;
        }

        function onError(error) {
            AlertService.error(error.data && error.data.message ? error.data.message : 'Error loading firms');
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'name') {
                result.push('name');
            }
            return result;
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.searchQuery,
                missingOnly: vm.missingOnly ? 'true' : null
            });
        }

        function openFirm(firm) {
            if (!firm || !firm.firmId) {
                return;
            }
            $state.go('appraisal-firm.edit', { id: firm.firmId });
        }
    }
})();
